import React, { createContext, useEffect, useState } from "react";
import {BASE_URL} from '../baseUrl'
export const UserContext = createContext();

export const UserProvider = (props) => {
  //const [token, setToken] = useState(localStorage.getItem("tkn_2050"));

    const [login, setLogin] = useState({
        //token: localStorage.getItem("tkn_2050"),
        token:"",
        id_user: 0,
        name: "",
        email:"",
        category:"",
        id_client: 0,
        id_corp: 0,
        isLoggedIn: false,
    });
    
    useEffect(() => {
        
        const fetchUser = async () => {
            const requestOptions = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + login.token,
                },
            };

            const response = await fetch(BASE_URL + "/api/users/me", requestOptions);
            const data = await response.json();
            console.log("Value returned after the get current user")
            console.log(data)
            if (!response.ok){
                //setToken(null);
                setLogin({ token: null, id_user:0,isLoggedIn: false });
            }else{
                setLogin({  token: login.token, 
                            id_user:data.ID_User, 
                            name: data.Name,
                            email: data.Email,
                            category: data.Category,
                            id_client: data.ID_Client,
                            id_corp: data.ID_Corp,
                            isLoggedIn: true })  
            }
            localStorage.setItem("tkn_2050", login.token);   
        };
            
        if (login.token) { // Only fetch user if token is present
            fetchUser();
        }
            //fetchUser();
    }, [login.token]);

    return (
    //<UserContext.Provider value={[token, setToken]}>
    <UserContext.Provider value={[login,setLogin]}>
        {props.children}
    </UserContext.Provider>
    );
};